import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { withRouter } from 'kts-platform-frame/routes';
import { create } from 'kts-scaffold-framework/utils/form';
import { invoiceInput } from 'src/api';
import { Button, Row, Form, Select, message, DatePicker, Col } from 'antd';
const FormItem = Form.Item;
/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    onClose: () => void;
    refreshData:(data:any)=>void;
}

/** 绑定全局数据到props */
@withRouter
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
/**
 * 关联行弹框
 */
export default class Header extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
        this.state = {
            data: null,
        };
    }
    componentDidMount() {

    }
    onSubmit = () => {
        this.props.form.validateFields((err, values) => {
            if (err) {
                return;
            }
            
            invoiceInput.realCheck(this,values['loggedDate'].format('YYYY-MM-DD')).then(response=>{
                const err2=response.er;
                const res=response.res;
                if(!err2){
                    message.success("操作成功");
                   
                    this.props.refreshData({});
                    this.props.onClose();
                }
            });
        });
    }
    render() {

        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: {
              xs: { span: 24 },
              sm: { span: 8 },
            },
            wrapperCol: {
              xs: { span: 24 },
              sm: { span: 16 },
            },
          };
        return (
            <div style={{ padding: 20 }}>
                <Form >
                    <Row>
                        <FormItem label="录入日期" {...formItemLayout}>
                            {getFieldDecorator('loggedDate', {
                                rules: [
                                    {
                                        required: true,
                                        message: '必填项'
                                    }
                                ]
                            })(
                                <DatePicker />
                            )}
                        </FormItem>
                    </Row>

                    <Row>
                        <Col span={8}></Col>
                        <Button type="primary" className='mr10' onClick={this.onSubmit}>提交</Button>
                        <Button onClick={this.props.onClose}>关闭</Button>
                    </Row>
                </Form>
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/display/apps/InvoiceInput/ReTryForm.tsx